import { Icon } from '@chakra-ui/react';

const PCProgressIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 59.07 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>
		<g>
			<g>
				<path class="st0" d="M58.93,19.98c-0.05-2.16-1.65-3.79-3.81-3.79c-16.96-0.02-33.92-0.02-50.88,0c-2.22,0-3.8,1.64-3.84,3.89
			c-0.02,1.14-0.01,2.29,0,3.43c0,2.89,1.49,4.37,4.39,4.37c8.31,0,16.62,0,24.93,0c8.39,0,16.79,0.01,25.19,0
			c2.4,0,4-1.59,4.03-3.96C58.95,22.61,58.96,21.29,58.93,19.98z M57.4,24.1c-0.04,1.25-0.93,2.22-2.16,2.23
			c-3.47,0.05-6.93,0.01-10.49,0.01v-0.11h-2.73c-0.22,0.09-0.55,0-0.82,0H4.69c-1.79,0-2.66-0.83-2.69-2.61
			c-0.02-1.06-0.02-2.12,0-3.18c0.03-1.76,0.9-2.66,2.67-2.66c0.13,0,0.27,0,0.4,0c0.85-0.01,1.71-0.01,2.57-0.01
			c3.14-0.01,6.28,0,9.42,0h27.69v-0.05c3.61,0,7.16-0.07,10.7,0.04c1.17,0.03,1.89,0.94,1.95,2.14C57.46,21.3,57.45,22.7,57.4,24.1
			z"/>
				<path class="st1" d="M2,23.63c-0.02-1.06-0.02-2.12,0-3.18C1.98,21.51,1.98,22.57,2,23.63z" />
				<path class="st1" d="M43.04,17.78c0,2.67,0.03,5.12-0.04,7.58c-0.01,0.3-0.55,0.65-0.92,0.86c-0.22,0.13-0.58,0.02-0.88,0.02
			c-12.17,0-24.34,0-36.51,0c-1.79,0-2.66-0.83-2.69-2.61c-0.02-1.06-0.02-2.12,0-3.18c0.03-1.76,0.91-2.66,2.68-2.67
			c3.48-0.02,6.95-0.01,10.43-0.01c8.78,0,17.56,0,26.33,0C41.94,17.78,42.44,17.78,43.04,17.78z"/>
			</g>
			<g>
				<path class="st0" d="M19.52,1.81c-1.38,0-2.47,0.38-3.24,1.15c-0.78,0.76-1.17,1.83-1.17,3.21c0,1.27,0.31,2.25,0.92,2.95
			c0.61,0.7,1.48,1.04,2.6,1.04c0.78,0,1.44-0.18,1.98-0.55c0.54-0.37,0.9-0.88,1.08-1.56h0.16c-0.01,3.27-1.92,4.99-5.75,5.15
			l0.18,1.72c2.56-0.13,4.46-0.83,5.71-2.12c1.25-1.28,1.87-3.16,1.87-5.61V6.4c0-1.57-0.35-2.73-1.06-3.47
			C22.11,2.18,21.01,1.81,19.52,1.81z M21.25,7.83c-0.45,0.44-1.1,0.65-1.94,0.65c-0.74,0-1.3-0.2-1.7-0.6
			c-0.4-0.4-0.59-0.97-0.59-1.72c0-0.85,0.21-1.51,0.64-1.98c0.43-0.47,1.03-0.71,1.8-0.71c0.78,0,1.39,0.22,1.82,0.66
			c0.44,0.44,0.65,1.06,0.65,1.84C21.93,6.78,21.7,7.4,21.25,7.83z"/>
				<path class="st0" d="M30.94,6.34c-0.48,0-0.95,0.05-1.42,0.14c-0.21,0.04-0.42,0.11-0.64,0.19l0.1-3.12h5.06V1.86h-5.01h-1.23
			H27.1l-0.18,6.71h1.02c0.74-0.4,1.53-0.6,2.38-0.6s1.5,0.23,1.96,0.69c0.46,0.46,0.69,1.1,0.69,1.93c0,0.85-0.21,1.5-0.64,1.97
			c-0.42,0.47-1.02,0.7-1.8,0.7c-0.79,0-1.39-0.19-1.81-0.56c-0.42-0.37-0.64-0.89-0.64-1.56h-1.94c0,1.2,0.38,2.14,1.14,2.8
			c0.76,0.66,1.84,0.99,3.23,0.99c0.93,0,1.71-0.17,2.36-0.51c0.65-0.34,1.14-0.83,1.48-1.48c0.34-0.65,0.51-1.43,0.51-2.35
			c0-1.35-0.34-2.4-1.03-3.14S32.19,6.34,30.94,6.34z"/>
				<polygon class="st0" points="45.11,4.71 36.68,10.73 37.51,11.97 45.95,5.89 		" />
				<path class="st0" d="M45.63,9.87c-0.52-0.54-1.2-0.8-2.05-0.8c-0.86,0-1.55,0.27-2.07,0.8c-0.52,0.53-0.78,1.25-0.78,2.14
			c0,0.88,0.26,1.58,0.78,2.12c0.52,0.54,1.21,0.8,2.07,0.8c0.85,0,1.54-0.27,2.05-0.8c0.52-0.54,0.78-1.24,0.78-2.12
			C46.4,11.11,46.14,10.4,45.63,9.87z M44.43,13.05c-0.22,0.27-0.51,0.4-0.86,0.4c-0.37,0-0.66-0.13-0.88-0.4
			c-0.22-0.27-0.33-0.61-0.33-1.04c0-0.44,0.11-0.8,0.33-1.06c0.22-0.27,0.51-0.4,0.88-0.4c0.36,0,0.64,0.13,0.86,0.4
			c0.22,0.27,0.33,0.62,0.33,1.06C44.76,12.43,44.65,12.78,44.43,13.05z"/>
				<path class="st0" d="M39.16,7.54c0.85,0,1.54-0.27,2.05-0.8c0.52-0.54,0.78-1.24,0.78-2.12c0-0.91-0.26-1.62-0.78-2.15
			c-0.52-0.53-1.2-0.79-2.05-0.79c-0.86,0-1.55,0.27-2.07,0.8c-0.52,0.54-0.78,1.25-0.78,2.14c0,0.88,0.26,1.58,0.78,2.12
			C37.62,7.27,38.3,7.54,39.16,7.54z M38.28,3.54c0.22-0.27,0.51-0.4,0.88-0.4c0.36,0,0.64,0.13,0.86,0.4
			c0.22,0.27,0.33,0.63,0.33,1.07c0,0.43-0.11,0.78-0.33,1.04c-0.22,0.27-0.51,0.4-0.86,0.4c-0.37,0-0.66-0.13-0.88-0.4
			c-0.22-0.27-0.33-0.61-0.33-1.04C37.96,4.17,38.07,3.81,38.28,3.54z"/>
			</g>
		</g>
		
	</Icon>
);

export default PCProgressIcon;
